"use strict";
const EMPTY_OBJECT = Object.freeze(/* @__PURE__ */ Object.create(null));
const EMPTY_ARRAY = Object.freeze([]);
function createEmptyObject() {
  return /* @__PURE__ */ Object.create(null);
}
function getEmptyObject(mutable = false) {
  return mutable ? createEmptyObject() : EMPTY_OBJECT;
}

export { EMPTY_ARRAY, EMPTY_OBJECT, createEmptyObject, getEmptyObject };
